export const getInitials = (fullName: string) => {
  if (!fullName.length) {
    return fullName
  }

  const allNames = fullName.split(' ')
  let primaryNames

  if (allNames.length > 2) {
    const firstName = allNames.shift()
    const lastName = allNames.pop()
    primaryNames = [firstName, lastName]
  } else {
    primaryNames = allNames
  }

  return primaryNames
    .map(name => name?.charAt(0))
    .join('')
    .toUpperCase()
}
